"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const NewEmailSubmitButton_1 = require("./NewEmailSubmitButton");
const reactstrap_1 = require("reactstrap");
const react_if_1 = require("react-if");
const inputs_1 = require("../../../../../inputs");
exports.NewEmailModal = props => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { state: { modalIsOpen, template, templateVersion, name, modalCanClose }, setState, isDisabled, } = props;
    const close = react_1.useCallback(() => setState({ modalIsOpen: !modalIsOpen }), [
        modalIsOpen,
        setState,
    ]);
    const toggler = modalCanClose && close ? close : undefined;
    return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "NewEmailModal", isOpen: modalIsOpen, toggle: toggler },
        react_1.default.createElement(react_2.OsmosysModal.Header, { toggle: toggler }, "Start new email"),
        react_1.default.createElement(react_2.OsmosysModal.Body, null,
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Label, null, "Email name"),
                react_1.default.createElement(reactstrap_1.Input, { value: name, placeholder: "Email Name", onChange: ({ target }) => {
                        setState({
                            name: target.value,
                        });
                    } })),
            react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailTemplate", value: template, onChange: (newTemplate) => setState({
                    template: newTemplate,
                }) }),
            react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailTemplateVersion", disabled: !template, value: templateVersion, emailTemplateId: (_a = template) === null || _a === void 0 ? void 0 : _a.id, productionVersionId: (_c = (_b = template) === null || _b === void 0 ? void 0 : _b.productionVersion) === null || _c === void 0 ? void 0 : _c.id, stagingVersionId: (_e = (_d = template) === null || _d === void 0 ? void 0 : _d.stagingVersion) === null || _e === void 0 ? void 0 : _e.id, developmentVersionId: (_g = (_f = template) === null || _f === void 0 ? void 0 : _f.developmentVersion) === null || _g === void 0 ? void 0 : _g.id, onChange: (newTemplateVersion) => setState({
                    templateVersion: newTemplateVersion,
                }) }),
            react_1.default.createElement(NewEmailSubmitButton_1.NewEmailSubmitButton, Object.assign({}, props, { isDisabled: isDisabled })),
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: isDisabled },
                react_1.default.createElement("p", { className: "mb-0 mt-2 small text-muted" },
                    react_1.default.createElement(react_if_1.Switch, null,
                        react_1.default.createElement(react_if_1.Case, { condition: !name }, "Missing email name"),
                        react_1.default.createElement(react_if_1.Case, { condition: !template }, "Missing template"),
                        react_1.default.createElement(react_if_1.Case, { condition: !templateVersion }, "Missing template version")))))));
};
//# sourceMappingURL=NewEmailModal.js.map